<template>
<div class="RedeemCodeList">
    <div class="filters">
        <div class="add">
            <el-button type="primary" @click="handleDownTemplate">下载模板</el-button>
            <el-upload class="upload-demo" action="" :auto-upload="false" :on-change="handleImport">
                <el-button type="success">导入</el-button>
            </el-upload>
            <el-button @click="handleExport">导出</el-button>
        </div>
        <div class="search">
        </div>
    </div>
    <div class="result-list btn-operate-list bgc">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column prop="code" label="兑换码"></el-table-column>
            <el-table-column prop="orderno" label="使用订单号" class-name="center">
                <template slot-scope="scope">
                    {{scope.row.orderno?scope.row.orderno: '-'}}
                </template>
            </el-table-column>
            <el-table-column prop="usetime" label="使用时间" class-name="center">
                <template slot-scope="scope">
                    {{scope.row.usetime?scope.row.usetime: '-'}}
                </template>
            </el-table-column>
            <el-table-column prop="status" label="使用状态" class-name="center">
                <template slot-scope="scope">
                    <span :class="[scope.row.status?'tc-blue':'tc-red']">{{scope.row.status?'已使用':'未使用'}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" label-class-name="tr">
                <template slot-scope="scope">
                    <div class="tr">
                        <span>
                            <el-button @click="handleDel(scope.row)" type="text" size="small" v-if="!scope.row.status">删除</el-button>
                        </span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <dialogPage :total="total" @getList="_getList" ref="dialogPage"></dialogPage>
    </div>
</div>
</template>

<script>
import {getDisEventExchangeCodePageList, delDisEventExchangeCode, importExchangeCode, exportExchangeCode} from 'api/nationalDistribution'
import {mapGetters, mapActions} from 'vuex'
import {nationalDistribution} from 'api/message'
import {dateFormat} from 'common/js/tools'
import DialogPage from 'base/page/dialogPage'
export default {
    name: 'RedeemCodeList',
    data() {
        return {
            param: {
                eventinnerid: this.$route.query.id ? this.$route.query.id : ''
            },
            tableData: [],
            total: 0,
            publicPath: process.env.BASE_URL
        }
    },
    mounted() {
        this._getList()
    },
    methods: {
        handleDownTemplate() {
            var link = document.createElement('a')
            // link.href = `${this.publicPath}template/code.xls`
            link.href = `http://img.jingketong.cn/download/dis_eccode_template.xlsx`
            link.download = 'code.xls'
            link.click() // 释放内存
            window.URL.revokeObjectURL(link.href)
        },
        handleImport(file) {
            const fileInfo = file.raw
            let formData = new FormData()
            formData.append('eventinnerid', this.param.eventinnerid)
            formData.append('importexcel', fileInfo)
            importExchangeCode({
                data: formData,
                success: data => {
                    this.$message.success('导入成功')
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleExport() {
            this.setLoading(true)
            exportExchangeCode({
                data: {eventinnerid: this.param.eventinnerid},
                success: data => {
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '兑换码' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        handleDel(row) {
            this.$confirm(nationalDistribution.redeemDel.msg, nationalDistribution.redeemDel.title, {
                confirmButtonText: nationalDistribution.redeemDel.confirmText,
                cancelButtonText: nationalDistribution.redeemDel.cancelText
            }).then(() => {
                this._editStatus(this.param.eventinnerid, row.code, nationalDistribution.redeemDel.successMsg)
            }).catch(() => {})
        },
        handleAdd() {

        },
        _editStatus(innerid, code, tip) {
            this.setLoading(true)
            delDisEventExchangeCode({
                data: {
                    innerid: innerid,
                    code: code
                },
                success: data => {
                    this.$message.success(tip)
                    this.setLoading(false)
                    this._getList()
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        _getList() {
            this.setLoading(true)
            getDisEventExchangeCodePageList({
                data: Object.assign({}, this.param, this.dialogPage),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'dialogPage',
            'user',
            'permission',
            'params'
        ])
    },
    components: {
        DialogPage
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/index";
.RedeemCodeList {
    .filters{
        background: #fff;
        border-bottom: 1px solid $line;
        padding: 10px 20px;
        margin:0;
        .add{
            display: flex;
            .upload-demo{
                margin: 0 20px;
            }
        }
    }
    .result-list{
        padding: 10px 20px;
        .el-table__row{
            height: 55px;
        }
        .center{
            .cell{
                text-align: center;
            }
        }
    }
}
</style>
